import type { FormEvent } from 'react';
import { SubscriptionConfirmation } from './SubscriptionConfirmation';
import { NewsletterForm } from './NewsletterForm';

interface NewsletterSignupProps {
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
  hasError: boolean;
  isPending: boolean;
  isSubscribed: boolean;
}

export const NewsletterSignup = ({
  handleSubmit,
  hasError,
  isPending,
  isSubscribed,
}: NewsletterSignupProps) =>
  isSubscribed ? (
    <SubscriptionConfirmation />
  ) : (
    <NewsletterForm handleSubmit={handleSubmit} hasError={hasError} isPending={isPending} />
  );
